export const TOGGLE_CHAT = 'TOGGLE_CHAT';
export const CHAT_BLOCKED = 'CHAT_BLOCKED';

export const chatBlockStatus = (chatBlocked) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: CHAT_BLOCKED,
                chatBlocked: chatBlocked,
            }),
        );
    };
};

export const toggleChat = (chatIsOpen) => {
    return (dispatch, getState) => {
        if (typeof zE === 'function') {
            zE('messenger', chatIsOpen ? 'open' : 'close');
        } else if (__isBrowser__ && !getState().app.isShowModal && !getState().app.isShowPopup && !getState().isShowNavBar) {
            document.documentElement.style.overflow = chatIsOpen ? 'hidden' : '';
            document.body.style.overflow = chatIsOpen ? 'hidden' : '';
        }
        return Promise.resolve(
            dispatch({
                type: TOGGLE_CHAT,
                chatIsOpen: chatIsOpen,
            }),
        );
    };
};
